// src/components/ambassador/AmbassadorApp.jsx
//
// Shell of the ambassador field app (/ambassador/*), mobile first: login
// (ROLE_SALES, or ROLE_ADMIN with an ambassador account), the ambassador's
// state from GET /api/ambassador/me shared with every screen through
// useAmbassador(), and the bottom navigation. Screens render in <Outlet />.
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box, BottomNavigation, BottomNavigationAction, CircularProgress, Alert, Container, Paper } from '@mui/material';
import useRoleAuth from '../../utils/useRoleAuth';
import { ambassadorGet } from '../../utils/ambassadorApi';
import { errorText } from '../../utils/ambassadorStatus';

const ROLES = ['ROLE_SALES', 'ROLE_ADMIN'];
const AmbassadorContext = createContext(null);
export const useAmbassador = () => useContext(AmbassadorContext);

const TABS = [
  ['/ambassador', 'Accueil', '🏠'],
  ['/ambassador/map', 'Carte', '🗺️'],
  ['/ambassador/new', 'Ajouter', '➕'],
];

export default function AmbassadorApp() {
  const { ready, forbidden, loading, getToken, logout } = useRoleAuth(ROLES);
  const [me, setMe] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const reloadMe = useCallback(() => {
    if (!ready) return Promise.resolve();
    return ambassadorGet('/me', getToken())
      .then((d) => { setMe(d); setError(null); })
      .catch((e) => setError(e));
  }, [ready, getToken]);
  useEffect(() => { reloadMe(); }, [reloadMe]);

  if (loading || (ready && !me && !error)) return <Box sx={{ p: 6, textAlign: 'center' }}><CircularProgress /></Box>;
  if (forbidden) return <Container sx={{ py: 4 }}><Alert severity="error">Espace réservé aux ambassadeurs QRProofs.</Alert></Container>;
  if (error && !me) return <Container sx={{ py: 4 }}><Alert severity="error">{errorText(error)}</Alert></Container>;

  const tab = TABS.findIndex(([path]) => (path === '/ambassador' ? location.pathname === path : location.pathname.startsWith(path)));
  return (
    <AmbassadorContext.Provider value={{ me, reloadMe, getToken, logout }}>
      <Box sx={{ pb: 9, minHeight: '100vh', bgcolor: '#f4f6fb' }}>
        <Outlet />
      </Box>
      <Paper elevation={8} sx={{ position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 1100 }}>
        <BottomNavigation showLabels value={tab} onChange={(_e, i) => navigate(TABS[i][0])}>
          {TABS.map(([path, label, icon]) => (
            <BottomNavigationAction key={path} label={label} icon={<span style={{ fontSize: 22 }} aria-hidden>{icon}</span>} />
          ))}
        </BottomNavigation>
      </Paper>
    </AmbassadorContext.Provider>
  );
}
